import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FieldSet } from "../../elements";
import EnrollmentSummaryPendencies from "../../forms/EnrollmentSummaryPendencies";

const PendencyList = ({
  pendencies,
  loadingPendencies,
  reloadPendencies,
  enrollmentId,
}) => {
  return (
    <>
      <FieldSet title="Pendências" />
      {loadingPendencies ? (
        <div className="text-center">
          <FontAwesomeIcon className="green" icon="spinner" pulse />
        </div>
      ) : (
        <>
          {pendencies.map((p) => (
            <div className="pendencies">
              <EnrollmentSummaryPendencies
                enrollmentId={enrollmentId}
                pendency={p}
                reloadPendencies={reloadPendencies}
              />
            </div>
          ))}
        </>
      )}
    </>
  );
};

PendencyList.propTypes = {
  pendencies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      step: PropTypes.string,
      description: PropTypes.string,
      created_at: PropTypes.string,
    })
  ).isRequired,
  loadingPendencies: PropTypes.bool.isRequired,
};

export default PendencyList;